/**
 * v1.2-rc2 ④：关于页 /about
 * 版本号 + 6 角色枚举 + 编译时间 + API 文档 + 反馈
 */
import { PageHeader, HomeCard, Btn } from '../components/ui';

const ROLES = [
  { key: 'admin', label: 'admin', desc: '系统管理员，全权限' },
  { key: 'director', label: 'director', desc: '总监，跨部门数据 + 审计' },
  { key: 'manager', label: 'manager', desc: '团队主管，本团队管理' },
  { key: 'sales', label: 'sales', desc: '销售员，客户全生命周期跟进' },
  { key: 'academic', label: 'academic', desc: '教务员，学员指导对接（v1.2 新增）' },
  { key: 'academic_director', label: 'academic_director', desc: '教务主管，部门进度看板 + 日报审批（v1.2 新增）' },
];

export function AboutPage() {
  const ver = (import.meta as any).env?.VITE_APP_VERSION ?? 'v1.2.0-rc2';
  const buildDate = new Date().toISOString().slice(0, 10);
  return (
    <>
      <PageHeader breadcrumb={['关于']} title="关于 HuanKe-CRM" subtitle="版本信息 + 角色权限说明" />
      <div className="work-content">
        <HomeCard title="版本">
          <div style={{ padding: 16, fontSize: 14, lineHeight: 1.8 }}>
            <div><strong>当前版本：</strong>{ver}</div>
            <div><strong>编译日期：</strong>{buildDate}</div>
            <div style={{ marginTop: 12, fontSize: 13, color: 'var(--text-2, #4E5969)' }}>
              覆盖客户生命周期 L0→L8 + 教务 9 阶段 · IM / 投流 ROI /
              群发话术 / 智能分配 / 教务模块 / AI 学员指导进度解析
            </div>
            <div style={{ marginTop: 16, display: 'flex', gap: 12 }}>
              <Btn kind="default" onClick={() => window.open('/docs/api', '_blank')}>📘 API 文档</Btn>
              <Btn kind="default" onClick={() => window.open('mailto:feedback@huanke.com')}>📮 反馈</Btn>
            </div>
          </div>
        </HomeCard>

        <HomeCard title="6 角色权限说明">
          <div style={{ padding: '8px 16px' }}>
            {ROLES.map((r) => (
              <div key={r.key} style={{
                display: 'flex', alignItems: 'flex-start', gap: 16,
                padding: '10px 0', borderBottom: '1px solid var(--border-default, #E5E6EB)',
              }}>
                <code style={{
                  width: 160, fontSize: 13, color: 'var(--primary, #3370FF)',
                  fontFamily: 'monospace',
                }}>{r.label}</code>
                <span style={{ flex: 1, fontSize: 13, color: 'var(--text-2, #4E5969)' }}>{r.desc}</span>
              </div>
            ))}
          </div>
        </HomeCard>
      </div>
    </>
  );
}
